<div class="d-flex">
  <div>
    <app-superadminsidenav></app-superadminsidenav>
  </div>
  <div
    style="
      height: 100vh;
      overflow: scroll;
      width: 100%;
      background-color: rgba(250, 250, 250, 1);
    "
  >
    <div class="container">
      <div class="allergens-head">
        <div
          class="allergensBtn"
          [ngClass]="{ bgSelectClass: allergensSlectedFlag }"
          (click)="allergensSelectFunc()"
        >
          Allergens
        </div>
        <div
          class="allergensBtn dietaryBtn"
          [ngClass]="{ bgSelectClass: dietarySlectedFlag }"
          (click)="dietarySlectFunc()"
        >
          Dietary Preference
        </div>
      </div>
      <div class="containerResto" *ngIf="allergensSlectedFlag">
        <div class="container-head">
          <span class="noOfRestoList">{{ lengthAllergens }} Allergens</span>
          <span class="resto-input">
            <div style="padding: 2px">
              <img src="../../../assets/images/Search.png" alt="" />
              <input
                placeholder="Allergens name"
                [(ngModel)]="searchText"
                (ngModelChange)="filter()"
              />
            </div>
          </span>
          <div class="addRestoBtn" (click)="addAllergens()">
            <div>
              <img src="../../../assets/images/Plus.png" alt="" />
              <span>Add Allergens</span>
            </div>
          </div>
        </div>
        <table
          mat-table
          [dataSource]="dataSource"
          class="mat-elevation-z8 demo-table"
        >
          <!-- Position Column -->
          <ng-container matColumnDef="SL-NO">
            <th mat-header-cell *matHeaderCellDef class="table-head checking">
              S.I<br />No.
            </th>
            <td
              mat-cell
              *matCellDef="let element; let i = index"
              class="table-element"
            >
              {{ i + 1 }}
            </td>
          </ng-container>

          <!-- Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="table-head checking">
              Allergens Name
            </th>
            <td mat-cell *matCellDef="let element" class="table-element">
              {{ element.allergens_name }}
            </td>
          </ng-container>
          `
          <!-- Weight Column -->
          <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef class="table-head checking">
              Edit
            </th>
            <td mat-cell *matCellDef="let element" class="table-element">
              <img
                src="../../../assets/images/editIcon.png"
                alt=""
                class="edit-element"
                (click)="editDialog(element.id)"
              />
            </td>
          </ng-container>

          <!-- Symbol Column -->

          <ng-container matColumnDef="action">
            <th
              mat-header-cell
              *matHeaderCellDef
              class="table-head action-th checking"
            >
              Action
            </th>
            <td
              mat-cell
              *matCellDef="let element"
              class="table-element action-element"
            >
              <img
                src="../../../assets/images/deletIcon.png"
                alt=""
                (click)="openDialog(element.id)"
              />
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
        <mat-paginator
          #paginator
          [pageSizeOptions]="[12, 20, 25]"
          showFirstLastButtons
        ></mat-paginator>
      </div>

      <!-- 2nd part -->
      <div class="containerResto" *ngIf="dietarySlectedFlag">
        <app-diet></app-diet>
      </div>
      <!-- <div class="modal" tabindex="-1">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Modal title</h5>
                  <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                  <p>Modal body text goes here.</p>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                  <button type="button" class="btn btn-primary">Save changes</button>
                </div>
              </div>
            </div>
          </div> -->
    </div>
  </div>
</div>
